"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useRef, useState } from "react";
import { useClickAway, useKeyPressEvent } from "react-use";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import { AuthContext } from "@/components/auth/Auth";
import { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import { AnimatePresence, motion } from "framer-motion";
import GroupCardDelete from "./delete/GroupCardDelete";
export default function GroupCardEditActions(t0) {
  const $ = _c(24);
  const {
    group,
    onEditClick
  } = t0;
  const {
    connectedProfile
  } = useContext(AuthContext);
  const [isOptionsOpen, setIsOptionsOpen] = useState(false);
  const listRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsOptionsOpen(false);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useClickAway(listRef, t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsOptionsOpen(false);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  useKeyPressEvent("Escape", t2);
  let t3;
  if ($[2] !== connectedProfile?.handle) {
    t3 = connectedProfile?.handle?.toLowerCase();
    $[2] = connectedProfile?.handle;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== group.created_by?.handle) {
    t4 = group.created_by?.handle?.toLowerCase();
    $[4] = group.created_by?.handle;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const isMyFilter = t3 === t4;
  const editTitle = isMyFilter ? "Edit" : "Clone";
  let t5;
  if ($[6] !== isOptionsOpen) {
    t5 = e => {
      e.stopPropagation();
      setIsOptionsOpen(!isOptionsOpen);
    };
    $[6] = isOptionsOpen;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="tw-sr-only">Open options</span>;
    t7 = <FontAwesomeIcon icon={faEllipsisVertical} className="tw-h-5 tw-w-5" aria-hidden="true" />;
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  let t8;
  if ($[10] !== isOptionsOpen || $[11] !== t5) {
    t8 = <button type="button" className="tw-bg-transparent tw-h-full tw-border-0 tw-block tw-text-iron-500 hover:tw-text-iron-50 tw-transition tw-duration-300 tw-ease-out" id="options-menu-0-button" aria-expanded={isOptionsOpen} aria-haspopup="menu" aria-controls="options-menu-0" onClick={t5}>{t6}{t7}</button>;
    $[10] = isOptionsOpen;
    $[11] = t5;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== editTitle || $[14] !== group || $[15] !== isMyFilter || $[16] !== isOptionsOpen || $[17] !== onEditClick) {
    t9 = isOptionsOpen && <motion.div id="options-menu-0" className="tw-absolute tw-right-0 tw-z-40 tw-mt-2 tw-w-32 tw-origin-top-right tw-rounded-lg tw-bg-iron-900 tw-py-2 tw-shadow-lg tw-ring-1 tw-ring-white/10 tw-focus:tw-outline-none" role="menu" aria-orientation="vertical" aria-labelledby="options-menu-0-button" initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -20
    }} transition={{
      duration: 0.2
    }}><div><button type="button" onClick={e_0 => {
          e_0.stopPropagation();
          onEditClick(group);
        }} className="tw-bg-transparent tw-w-full tw-border-none tw-block tw-px-3 tw-py-1 tw-text-sm tw-leading-6 tw-text-iron-300 hover:tw-text-iron-50 hover:tw-bg-iron-800 tw-text-left tw-transition tw-duration-300 tw-ease-out" role="menuitem" id="options-menu-0-item-0">{editTitle}</button>{isMyFilter && <GroupCardDelete group={group} />}</div></motion.div>;
    $[13] = editTitle;
    $[14] = group;
    $[15] = isMyFilter;
    $[16] = isOptionsOpen;
    $[17] = onEditClick;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = <AnimatePresence mode="wait" initial={false}>{t9}</AnimatePresence>;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t8) {
    t11 = <div className="tw-relative tw-z-40" ref={listRef}>{t8}{t10}</div>;
    $[21] = t10;
    $[22] = t8;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}